import React from "react";
import logo from "../../assets/images/logo.jpg";
import axios from "axios";
import severUrl from "../../api";
import { useEffect, useState } from "react";


export const DummyItem = (props) => {
  return (
    <>
      <div className="search-item">
          <div className="thumnails">
             <img loading="lazy" alt="thumnail-image" style={{maxWidth:"30%"}} src={logo} />
          </div>
        <div className="item-content" style={{
          borderBottom: "1px solid #d2d2d2", paddingTop: "3em",
          paddingBottom: "3em"
        }}>
          <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", width: "100%" }}>
            <a style={{ fontWeight: "bold", width: "fit-content", fontSize: "18px", maxWidth: "90%", marginBottom: "5px" }}>Parallel Programming Pariwise Conditional Gradient for Kernel Herding with Cuda C
            </a>
            <div style={{ fontWeight: "400", color: "black", textAlign: "end", marginLeft: "1px", fontSize: "13px" }}>10-Mar</div>
          </div>
          <a
            style={{ fontSize:"14px", height: "24px", fontWeight: "300", color: "green", backgroundColor: "transparent", border: "none", marginRight: "10px", borderRadius: "5px", paddingLeft: "0", marginTop: "2px" }}
          >v1.1</a>
          <div className="search-result-description" style={{ fontWeight: "1.7em" }}>This work is an attempt to analyze PCG which predefined step size. PCG has not swapped step which provide sparser solution. This analysis based on conditional number of simplex like polytope which is ...</div>
        </div>
      </div>
    </>
  );
};
